import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Card } from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const VendorPerformance = () => {
  const { data: vendors } = useQuery({
    queryKey: ["vendors-performance"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("vendors")
        .select("*")
        .order("total_sales", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  const performanceData = vendors?.map((vendor) => ({
    name: vendor.name,
    sales: vendor.total_sales || 0,
    rating: vendor.rating || 0,
    riskScore: vendor.ai_risk_score || 0,
  }));

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <h3 className="text-lg font-medium mb-4">Sales Performance</h3>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={performanceData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="sales" fill="#8884d8" name="Total Sales" />
              <Bar dataKey="rating" fill="#82ca9d" name="Rating" />
              <Bar dataKey="riskScore" fill="#ffc658" name="Risk Score" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>

      {vendors?.map((vendor) => (
        <Card key={vendor.id} className="p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium">{vendor.name}</h3>
              <span className="text-sm text-muted-foreground">
                {vendor.business_type}
              </span>
            </div>
            
            <div className="grid gap-4 md:grid-cols-3">
              <div>
                <p className="text-sm text-muted-foreground">Total Sales</p>
                <p className="text-2xl font-bold">{vendor.total_sales || 0}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Rating</p>
                <p className="text-2xl font-bold">{vendor.rating || 0}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Risk Score</p>
                <p className="text-2xl font-bold">{vendor.ai_risk_score || 0}</p>
              </div>
            </div>

            {vendor.performance_metrics && (
              <div className="mt-4 p-4 bg-muted rounded-md">
                <h4 className="font-medium mb-2">Performance Metrics</h4>
                <pre className="text-sm">
                  {JSON.stringify(vendor.performance_metrics, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default VendorPerformance;